module.exports = __webpack_public_path__ + "static/media/noWork.79c91638.png";